<template>
  <div class="box">
    <div class="l">{{ info.key }}</div>
    <div class="top red" v-show="filterJsonStrParse(info.vals[0].value,'value')"></div>
    <div class="top yellow" v-show="filterJsonStrParse(info.vals[1].value,'value')"></div>
    <!-- <div class="r2" :class="info.color">{{ info.val }}</div> -->
    <div class="after1"></div>
    <div class="after2"></div>
    <div class="after3"></div>
    <div class="after4"></div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  created(){
  },
  data() {
    return { };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$height: 0.15rem;
.box {
  position: relative;
  width: 100%;
  height: $height;
  line-height: $height;
  font-size: 0.05rem;
  color: #0f69ca;

}
.l { height: $height;
  display: inline;
  position: relative;
  float: left;
  font-size: 0.05rem;
}
.l::after {
  content: " ";
  display: block;
  position: absolute;
  left: 110%;
  top:  0.06rem;
  width: 0.1025rem;
  height: 0.04rem;
  background: url(../img/tafter.png);
  background-size: 100% 100%;
}
.r { height: $height;
  font-weight: 700;
  font-size: 0.07rem;
  width: 49%;
  float: right;
  text-align: right;
}
.top{
  // margin-right: 0.1rem;
  float: right;
  width: 0.15rem;
  height:  0.15rem;
  background-size: 100% 100%;
  background-position: 50% 50%;
}
.top.none{
   background-image:none;
}
.red {
  background-image: url(../img/red.png);
}
.yellow {
  background-image: url(../img/yellow.png);
}
.after1 {
  position: absolute;
  height: .01rem;
  left:0rem;
  width:.03rem;
  bottom:0rem;
  background: #0f69ca;
}
.after2 {
  position: absolute;
  height: 1px;
  left:.04rem;
  width: .06rem;
  bottom:0rem;
  background: #0f69ca;
}
.after3 {
  position: absolute;
  height: 1px;
  left:.12rem;
  right: 0;
  bottom:0rem;
  background: rgba($color: #0f69ca, $alpha: 0.12);
}
.after4 {
  position: absolute;
  height: .01rem;
  width:.05rem;
  right: 0;
  bottom:0rem;
  background: #0f69ca;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/valstatus/icon2.vue